export const support = {
  // Modal titles and descriptions
  supportTokenTitle: 'Token de suporte',
  supportTokenDescription: 'Informe este token ao atendente para autorizar o acesso temporário à sua conta.',
  
  // Timer and status
  validFor: 'Válido por:',
  expired: 'Expirado',
  expiredDescription: 'Este token não é mais válido.',
  
  // Buttons
  copyToken: 'Copiar token',
  regenerate: 'Regenerar',
  revoke: 'Revogar',
  generateNewToken: 'Gerar novo token',
  tryAgain: 'Tentar novamente',
  
  // Security note
  securityNote: 'O token é de uso único, expira em 30 minutos e não dá acesso ao seu e-mail ou senha.',
  
  // Toast messages
  tokenCopied: 'Copiado!',
  tokenCopiedDescription: 'Token copiado para a área de transferência.',
  tokenRevoked: 'Token revogado.',
  tokenRevokedDescription: 'Nenhum acesso está ativo agora.',
  newTokenGenerated: 'Novo token gerado.',
  
  // Error messages
  failedToGenerate: 'Não foi possível gerar o token. Tentar novamente.',
  offline: 'Você está offline. Verifique sua conexão.',
  rateLimitExceeded: 'Você gerou tokens demais hoje. Tente novamente em 1 hora.',
  
  // Loading state
  generating: 'Gerando token...',
};
